import { MEDIA_META } from '@/constants/api'

export const getMediaMetaQueryKey = (id: string) => [MEDIA_META, id]
